import { render, staticRenderFns } from "./SendGoodsInfo.vue?vue&type=template&id=0874084e&scoped=true"
import script from "./SendGoodsInfo.vue?vue&type=script&lang=js"
export * from "./SendGoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./SendGoodsInfo.vue?vue&type=style&index=0&id=0874084e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0874084e",
  null
  
)

export default component.exports